import { useEffect, useState } from "react";
import { osApi } from "./osApi";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const ROLE_COLORS = { admin: "os-badge-red", manager: "os-badge-blue", agent: "os-badge-green", telecaller: "os-badge-amber" };

export default function OSTeam() {
  const [items, setItems] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ email:"", password:"", name:"", phone:"", role:"agent" });

  const load = () => osApi.listTeam().then(r => setItems(r.items)).catch(() => toast.error("Failed"));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await osApi.createUser(form); toast.success("Team member added"); setShowAdd(false); setForm({ email:"", password:"", name:"", phone:"", role:"agent" }); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };

  const del = async (id) => {
    if (!confirm("Remove this team member?")) return;
    try { await osApi.deleteUser(id); toast.success("Removed"); load(); } catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-5" data-testid="os-team-page">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Team</h1>
          <p className="text-sm mt-1" style={{color:"var(--os-text-muted)"}}>Admin · Manager · Agent · Telecaller — full role control.</p>
        </div>
        <button onClick={() => setShowAdd(true)} className="os-btn" data-testid="os-add-user"><Plus className="w-3.5 h-3.5" /> Add member</button>
      </div>

      <div className="os-card overflow-hidden">
        <table className="os-table">
          <thead><tr><th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th></th></tr></thead>
          <tbody>
            {items.map(u => (
              <tr key={u.id} data-testid={`os-team-row-${u.email}`}>
                <td className="font-medium">{u.name}</td>
                <td className="text-xs">{u.email}</td>
                <td className="os-mono text-xs">{u.phone || "—"}</td>
                <td><span className={`os-badge ${ROLE_COLORS[u.role] || "os-badge-grey"}`}>{u.role}</span></td>
                <td>{u.role !== "admin" && (
                  <button onClick={() => del(u.id)} className="os-btn-danger p-1.5 rounded-md" data-testid={`os-team-delete-${u.email}`}><Trash2 className="w-3.5 h-3.5" /></button>
                )}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAdd && (
        <div className="os-drawer-overlay" onClick={() => setShowAdd(false)}>
          <div className="os-drawer" onClick={e => e.stopPropagation()}>
            <form onSubmit={add} className="p-6 space-y-4" data-testid="os-team-form">
              <h3 className="text-lg font-bold">Add team member</h3>
              <Field label="Name" v={form.name} on={v => setForm({...form, name:v})} req testid="os-team-name" />
              <Field label="Email" type="email" v={form.email} on={v => setForm({...form, email:v})} req testid="os-team-email" />
              <Field label="Password" type="password" v={form.password} on={v => setForm({...form, password:v})} req testid="os-team-password" />
              <Field label="Phone" v={form.phone} on={v => setForm({...form, phone:v})} testid="os-team-phone" />
              <label className="block">
                <div className="text-xs mb-1" style={{color:"var(--os-text-muted)"}}>Role</div>
                <select className="os-input" value={form.role} onChange={e => setForm({...form, role:e.target.value})} data-testid="os-team-role">
                  <option value="agent">Agent</option>
                  <option value="telecaller">Telecaller</option>
                  <option value="manager">Manager</option>
                  <option value="admin">Admin</option>
                </select>
              </label>
              <div className="flex gap-2 pt-2">
                <button className="os-btn" data-testid="os-team-save">Save</button>
                <button type="button" onClick={() => setShowAdd(false)} className="os-btn-ghost">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, v, on, type="text", req, testid }) {
  return (
    <label className="block">
      <div className="text-xs mb-1" style={{color:"var(--os-text-muted)"}}>{label}{req && " *"}</div>
      <input className="os-input" type={type} value={v} onChange={e => on(e.target.value)} required={req} data-testid={testid} />
    </label>
  );
}
